<!-- 直播视频 组件 -->
<template>
  <div class="v-video-wrap" :class="['v-live-rotate-' + degClass]">
    <div
      class="v-video-shadow-box"
      v-if="
        (vData.liveState == 1 && vData.judgeContact) 
        || (vData.liveState == 3 && !vData.playBackUrl && vData.judgeContact) 
        || vData.judgeContact == false
        || (vData.liveState == 2 && vData.judgeContact && vData.scope === 4)">
      <img :src="vData.liveImgUrl" alt="" />
    </div>
    <div class="v-video-hader flex-start align-center">
      <div class="img-box">
        <img :src="vData.anchorImgUrl ? vData.anchorImgUrl : '/static/login-img.png'" alt="" />
      </div>
      <div class="text-left">
        <div class="theme-color text-left  margin-b-8">
          <span class="iconfont iconzhibo theme-color font-size-16"></span><span>{{ $t('lives.status[' + vData.liveState + ']') }}</span>
        </div>
        <div class="font-size-14">{{ vData.anchorPost }} {{ vData.anchorName }}</div>
      </div>
    </div>
    <div class="v-video-play-btn v--video-img">
      <span class="icon-video hide"></span>
    </div>
    <div class="v-video-box text-center" v-if="vData.liveState == 1" @click="cb({ type: 'miss', data: vData })">
      <span :class="['iconfont iconxiangkan iconmisslook pointer iconmiss_bg2', isT ? 'animation1' : '']"></span>
      <span :class="['iconfont iconxiangkan iconmisslook pointer iconmiss_bg3', isT ? 'animation1' : '']"></span>
      <span :class="['iconfont iconxiangkan iconmisslook pointer iconmiss_bg4', isT ? 'animation1' : '']"></span>
      <span class="iconfont iconxiangkan iconmisslook pointer iconmiss_bg1"></span>
      <p class="font-size-14">{{ vData.liveWantCount }} {{ $t('lives.miss') }}</p>
    </div>
    <div class="v-video-box text-center" v-if="vData.liveState != 1" @click.stop="cb({ type: 'like', data: vData })">
      <span :class="['iconfont', 'iconact_dianzan_full', 'pointer', 'iconlike_color']"></span>
      <p class="font-size-14">{{ vData.liveLikeCount }} {{ $t('like') }}</p>
    </div>
    <div id="id_test_video" style="width:100%; height:520px;"></div>
    <!-- 弹幕 -->
    <div class="v-live-mess-wrap" v-if="isShowDanMuMoudlue&&isLogin">
      <div class="v-live-mess-box" v-if="isShowDanMu">
        <div :class="['v-live-list-box', isShowDanMu ? 'v-live-active' : '']">
          <div v-for="(item, index) in danMuAll" :key="index + Math.random()">
            <div :class="['v-live-item']" v-if="item.mess">
              <span class="v-tag">{{ item.name }}</span>
              {{ item.mess }}
            </div>
          </div>
        </div>
      </div>
      <div class="v-live-menu-box flex-start">
        <span class="iconfont iconwodewenjuan pointer" @click="isShowDanMu = !isShowDanMu" v-if="$store.getters.isLogin"></span>
        <span class="iconfont iconhengshuping pointer" @click="videoRotate"></span>
        <div class="v-live-text-box" v-if="$store.getters.isLogin">
          <input type="text" v-model="liveText" :placeholder="$t('lives.sendDanMuTip')"/>
          <span @click="cb({ type: 'sendDanMu', data: liveText })" v-on:keyup.enter="cb({ type: 'sendDanMu', data: liveText })" class="pointer btn">{{$t('lives.send')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { TcPlayer } from '@/utils/TcPlayer3.2.3'
import { watchLog } from '@/api/live'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'zhibovideo',
  props: {
    vData: {
      type: [Object],
      default: () => {}
    },
    vDanMuData: {
      type: [Object, Array],
      default: () => []
    },
    isShowDanMuMoudlue: {
      type: [Boolean],
      default: () => false
    },
    sendStatus: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      p: null,
      isT: false,
      liveText: '',
      liveTextArr: [],
      stopS: 0,
      danMuAll: [], //弹幕数据
      isShowDanMu: true,
      degClass:0,
      watchTimer: null 
    }
  },
  computed: {
        ...mapState({
            danmuData: state => state.danmuData
        }),
        ...mapGetters([ 'isLogin' ])
    },
  watch: {
    'vData.judgeContact': {
      handler() {
        this.playerInit()
      }
    },
    danmuData() {
      let elem = document.getElementsByClassName('v-live-list-box')
      elem = elem[elem.length - 1]
      elem.className = 'v-live-list-box'
      this.startSetTimeout(elem)
      this.danMuAll = this.danmuData
    }
  },
  created() {
    this.danMuAll = this.danmuData
  },
  mounted() {
    this.$once('hook:beforeDestroy', () => {
        this.stopWatchLog()
    }) 
  },
  beforeDestroy() {
    this.playDestroy()
  },
  methods: {
    // 直播组件初始化
    playerInit() {
        let _this = this
        let liveTip = _this.$t('logins.liveOver')
        let str = _this.vData.liveUrl
        let mp4 = str.replace('.m3u8', '.mp4')
        // let rtmp=str.replace('.m3u8','').replace('http://','rtmp://')
        _this.playDestroy()
        if (_this.vData.liveState == 2 && _this.vData.judgeContact && _this.vData.scope !== 4) {
          _this.p = new TcPlayer('id_test_video', {
            live: true,
            m3u8: _this.vData.liveUrl,
            flv: _this.vData.pullUrl, //增加了一个 flv 的播放地址，用于PC平台的播放 请替换成实际可用的播放地址
            // rtmp:rtmp,
            mp4: mp4,
            autoplay: true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
            poster: {"style":"cover", "src":_this.vData.liveImgUrl},
            wording: {
              2: '视频格式 Web 播放器无法解码。',
              3: '视频解码错误。',
              4: '当前系统环境不支持播放该视频格式。',
              5: '当前系统环境不支持播放该视频格式。',
              1001: '网络已断开',
              1002: liveTip,
              2032: '获取视频失败，请检查播放链接是否有效。',
              2048: '无法加载视频文件，跨域访问被拒绝。'
            },
            listener: function(msg) {
              if (msg.type == 'error') {
                console.log(msg)
              } else if (msg.type == 'play' && _this.$store.getters.isLogin) {
                _this.startWatchLog()
              } else if (msg.type == 'ended' && _this.$store.getters.isLogin) {
                _this.stopWatchLog()
              }
            },
            width: '1010', //视频的显示宽度，请尽量使用视频分辨率宽度
            height: '520' //视频的显示高度，请尽量使用视频分辨率高度
          })
        } else if (_this.vData.liveState == 3 && _this.vData.judgeContact) {
          // 回放
          if (!_this.vData.playBackUrl) return
          let p = {
            live: false,
            poster: {"style":"cover", "src": _this.$funcs.compressImage(_this.vData.liveImgUrl, 1010, 520)},
            listener: msg => {
              if (msg.type == 'play' && this.$store.getters.isLogin) {
                // 播放
                _this.startWatchLog()
              } else if (msg.type == 'pause') {
                // 暂停
                _this.vData.anchorImgUrl = ''
                if (this.$store.getters.isLogin) {
                  _this.stopWatchLog()
                }
              }
            },
            width: '1010', //视频的显示宽度，请尽量使用视频分辨率宽度
            height: '520' //视频的显示高度，请尽量使用视频分辨率高度
          }
          let pType = _this.vData.playBackType.toLocaleLowerCase()
          if (pType == 'mp4' || pType == 'flv') {
            p[pType] = _this.vData.playBackUrl
          } else if (pType == 'hls') {
            p['m3u8'] = _this.vData.playBackUrl
          }
          _this.p = new TcPlayer('id_test_video', p)
        }
    },
    // 直播组件销毁
    playDestroy() {
        if (this.p) {
            this.p.destroy()
            this.p = null
        }
    },
    startWatchLog(initialize=true) {
        if (!this.$route.params.id) return
        if ((this.vData.liveState === 3 ||this.vData.liveState === 2) && this.vData.judgeContact) {
            let watchType = this.vData.liveState === 3 ? 0 : 1
            this.stopWatchLog()
            if (initialize) {
                watchLog({ liveId: this.$route.params.id, watchType })
            }
            this.watchTimer = setInterval(() => {
                watchLog({ liveId: this.$route.params.id, watchType })
            }, 14000)
        }
    },
    stopWatchLog() {
        if (this.watchTimer) {
            clearInterval(this.watchTimer)
            this.watchTimer = null
        }
    },
    cb(param) {
      if (param.wantLive == 0 && param.type == 'miss') {
        //开启想看动画
        this.isT = true
      } else if(param.type=='sendDanMu'){
        this.liveText = ''
        if (!this.sendStatus) return
      }
      this.$emit('callback', param)
    },
    // 视频旋转
    videoRotate(){
      let num=this.degClass+1;
      if(num>3){
        num=0;
      }
      this.degClass=num;
    },
    startSetTimeout(elem) {
      let _this = this
      clearTimeout(_this.stopS)
      _this.stopS = setTimeout(() => {
        elem.className += ' v-live-active'
      }, 10)
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-video-wrap{
    position:relative;
    overflow hidden;
    background: $color-black-10
    .iconzhibo{
        margin-left:0;
        font-size: 18px;
    }
    .v-video-shadow-box{
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        background: $color-black-50;
        z-index:1;
        overflow:hidden;
        >img{
            width:100%;
            height: 100%;
            object-fit: cover;
        }
        &:after{
          content:'';
          position:absolute;
          top:0;
          left:0;
          width:100%;
          height:100%;
          background:$color-black-15;
        }
    }
    .v-video-hader{
        position:absolute;
        top:25px;
        left:25px;
        z-index:99;
        color:$color-white;
        .img-box{
            width:60px;
            height:60px;
            margin-right:14px;
            border-radius:50%;
        }
    }
    .v-video-play-btn{
        position:absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        z-index:99;
        .iconfont{
            color:$color-white;
            font-size:60px;
        }
    }
    .v-video-box{
        position:absolute;
        right:32px;
        bottom:50px;
        z-index:99;
        color:$color-white;
        user-select: none;

        .iconxiangkan{
            font-size:23px;
            color:$color-white;
        }
        .iconact_dianzan_full{
          font-size:23px;
          color:$color-white;
        }
        .iconlike_color{
          color:$color-red-f5;
        }

    }
    .iconmisslook{
        display: block;
        width: 46px;
        height: 46px;
        line-height: 46px;
        border-radius: 50%;
    }
    .iconmiss_bg1{
        background: $color-blue-49;
        position:relative;
        z-index:2;
    }
    .iconmiss_bg2{
        background:$color-blue-49;
        width:20px;
        height:20px;
        line-height:20px;
        position:absolute;
        top:0;
        left:10px;
        z-index:1;
        transition:all 2s ease;
        font-size:12px!important;
    }
    .iconmiss_bg3{
        background:$color-red-ed;
         width:20px;
        height:20px;
        line-height:20px;
         position:absolute;
        top:0;
        left:10px;
        z-index:1;
        transition:all 2s ease .5s;
        font-size:12px!important;
    }
    .iconmiss_bg4{
        background:$color-red-fc;
        width:20px;
        height:20px;
        line-height:20px;
         position:absolute;
        top:5px;
        left:10px;
        z-index:1;
        transition:all 2s ease 0.8s;
        font-size:12px!important;
    }
    .animation1{
      transform:translate(18px,-60px) scale(2) translate(-10px,-80px);
      opacity:0;
    }
    .hide{
      display:none;
    }
    .v-live-mess-wrap{
      width:400px;
      position: absolute;
      bottom:48px;
      left: 25px;
      color:#fff;
      .v-live-mess-box{
        position:relative;
        width:300px;
        height:208px;
        overflow:hidden;
      }
      .v-live-list-box{
        position:absolute;
        left:0;
        bottom:0;
        color:#fff;
        overflow:hidden;
        .v-live-item{
          padding: 10px;
          background: rgba(0,0,0,.4);
          border-radius: 5px;
          margin: 16px 0;
          max-width: 208px;
          word-break: break-word;
          transform:translateY(50px);
          font-size:12px;
          line-height: 1.8em;
        }
        &.v-live-active{
          .v-live-item{
            transition:all 1s linear;
            transform:translateY(0)!important;
          }
        }
      }
      .v-live-menu-box{
        align-items:center;
        .v-live-text-box{
          background:rgba(0,0,0,0.45);
          border-radius: 15px;
          padding: 0 15px;
          border:1px solid #CACACA;
        }
        input{
          height:32px;
          background: transparent;
          outline: none;
          border: 0;
          color:#fff;
        }
      }
      .btn{
        display: inline-block;
        padding-left: 10px;
        line-height: 32px;
        vertical-align: top;
        font-size: 14px;
      }
      .iconfont{
        margin: 8px 15px 8px 0;
        font-size:18px;
        background: rgba(0,0,0,.45);
        padding: 6px;
        border-radius: 50%;
        border:1px solid #CACACA;
      }
    }
    .v-tag{
      padding:3px 6px;
      box-sizing:border-box;
      color:$color-main;
      font-size:12px;
      background: #fff;
      border-radius: 2px;
    }
    
    ::-webkit-input-placeholder{
      color:#fff;
    }
}
</style>
